import { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { Tag as TagIcon, Trash2, Copy } from 'lucide-react';
import type { FlowNodeProps } from '@/types/flow';

const TagNode = ({ data, selected }: FlowNodeProps) => {
    const tagColor = data.tag_cor || '#10b981';
    const tagName = data.tag_nome || 'Sem tag';

    return (
        <div
            className={`
                bg-white rounded-lg shadow-sm min-w-[200px] max-w-[280px]
                transition-all duration-150 group
                ${selected ? 'shadow-md ring-2 ring-blue-400/40' : 'hover:shadow-md'}
            `}
            style={{ borderLeft: `3px solid ${tagColor}`, border: selected ? undefined : '1px solid #e5e7eb', borderLeftWidth: '3px', borderLeftColor: tagColor }}
        >
            <div className="px-3 py-2.5">
                <div className="flex items-center gap-2">
                    <div
                        className="w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0"
                        style={{ backgroundColor: `${tagColor}20` }}
                    >
                        <TagIcon className="w-3.5 h-3.5" style={{ color: tagColor }} />
                    </div>
                    <div className="flex-1 min-w-0">
                        <span className="text-[10px] text-gray-400 uppercase tracking-wider font-medium block">Tag</span>
                        <span className="font-semibold text-[13px] text-gray-800 block truncate">{tagName}</span>
                    </div>
                    <button
                        className="opacity-0 group-hover:opacity-100 transition-opacity p-1 rounded hover:bg-blue-50 text-gray-400 hover:text-blue-500"
                        title="Duplicar"
                        onClick={(e) => { e.stopPropagation(); data.onDuplicate?.(data.id); }}
                    >
                        <Copy className="w-3 h-3" />
                    </button>
                    <button
                        className="opacity-0 group-hover:opacity-100 transition-opacity p-1 rounded hover:bg-red-50 text-gray-400 hover:text-red-500"
                        onClick={(e) => { e.stopPropagation(); data.onDelete?.(data.id); }}
                    >
                        <Trash2 className="w-3 h-3" />
                    </button>
                </div>
            </div>

            <Handle type="target" position={Position.Left} id="target" className="!w-3.5 !h-3.5 !bg-[#2196F3] !border-2 !border-white" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.2)' }} />
            <Handle type="source" position={Position.Right} id="source" className="!w-3.5 !h-3.5 !bg-[#2196F3] !border-2 !border-white" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.2)' }} />
        </div>
    );
};

export default memo(TagNode);
